/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

// This file was ported from WebSDK/src/sdk/audio/AudioSpeakerDetectionAlgorithm.js

export default class AudioSpeakerDetectionAlgorithm {
  static defaultSpeakingHysteresisInterval = 50;
  static defaultSilenceHysteresisInterval = 1500;

  constructor() {
    this._callback = null;
  }

  onValue(callback) {
    this._callback = callback;
  }

  startDetection(audioVolumeMeter, options) {
    return this._startAudioDetection(audioVolumeMeter, options);
  }

  _startAudioDetection(audioVolumeMeter, options = {}) {
    const stopped = false;
    const speakingHysteresisInterval = options.speakingHysteresisInterval || AudioSpeakerDetectionAlgorithm.defaultSpeakingHysteresisInterval;
    const silenceHysteresisInterval = options.silenceHysteresisInterval || AudioSpeakerDetectionAlgorithm.defaultSilenceHysteresisInterval;
    let speaking = false;
    let nextSpeakingDeadline = Date.now() + speakingHysteresisInterval;
    let nextSilenceDeadline = Date.now() + silenceHysteresisInterval;

    audioVolumeMeter.onValue((value) => {
      if (stopped) {
        return;
      }

      const speakingThreshold = value.value > 0.01 && value.value > 2 * value.smoothedValue && value.value > 0.25 * value.smoothedPeakValue;
      const speakingContinuationThreshold = value.value > 0.8 * value.smoothedValue;
      const notSpeakingThreshold = value.value < 0.5 * value.smoothedValue;
      const notSpeakingContinuationThreshold = !speakingThreshold;

      if ((speakingThreshold || (speaking && speakingContinuationThreshold)) && nextSpeakingDeadline < value.date) {
        nextSilenceDeadline = value.date + silenceHysteresisInterval;

        if (!speaking) {
          speaking = true;

          console.info('Speaking detected');

          if (this._callback) {
            this._callback('speaking');
          }
        }
      } else if ((notSpeakingThreshold || (!speaking && notSpeakingContinuationThreshold)) && nextSilenceDeadline < value.date) {
        nextSpeakingDeadline = value.date + speakingHysteresisInterval;

        if (speaking) {
          speaking = false;

          console.info('Silence detected');

          if (this._callback) {
            this._callback('silence');
          }
        }
      }
    });
  }
}